import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { StoryblokService } from '../services/storyblok.service';
// import { Components } from './components';
import { Competitor } from '../services/compare-replace.service';
import { containsComponent } from './storyblok-find-components';

export const storyblokCompetitorsResolver: ResolveFn<Observable<Competitor[]>> = route => {
  const path = route.url.map(segment => segment.path).join('/') || 'home';
  const storyblokService = inject(StoryblokService);
  return storyblokService.getStory(path, route).pipe(
    switchMap(resp => {
      const story = resp && resp.story;
      if (!story) return of(undefined);
      return storyblokService.resolveRelationships(route).pipe(
        switchMap(relationships => {
          const componentTypes: unknown[] = ['CompetitorList'];
          if (componentTypes.some(type => containsComponent([story.content, ...relationships], type))) {
            return storyblokService.getStories({ content_type: 'Competitor' }) as Observable<Competitor[]>;
          }
          return of(undefined);
        })
      );
    })
  );
};
